// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBusinessShoppingBasket = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.062 9h7.884l-3.7-5.38a.266.266 0 0 0-.434-.001zM6.177 9l4.336-6.221c.726-1.042 2.319-1.038 3.038.009L17.823 9h4.178a1 1 0 0 1 .965 1.264l-2.743 10a1 1 0 0 1-.964.736H4.74a1 1 0 0 1-.964-.736l-2.743-10A1 1 0 0 1 2 9zM6 11H3.506a.15.15 0 0 0-.144.19l2.04 7.442a.5.5 0 0 0 .483.368h12.497a.15.15 0 0 0 .144-.11l2.112-7.7a.15.15 0 0 0-.145-.19H7.566z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBusinessShoppingBasket;
